:host {
  --dropdown-width: 100px;
}

.#{$prefix}paging {
  display: grid;
  grid-template-columns: auto auto auto;
  padding-top: 32px;
  opacity: 1;
  transition: opacity 0.2s ease;

  @include for-size(phone) {
    grid-template-columns: auto;
    grid-template-areas:
      "top"
      "bottom";
    gap: 24px;
  }

  @include for-size(desktop-or-smaller) {
    padding-top: 24px;
  }

  &__column {
    white-space: nowrap;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    eon-ui-dropdown {
      display: flex;
      flex-direction: row;
      gap: 8px;
      width: auto;
    }

    .#{$prefix}sr-only {
      @include hideReadable;
    }

    &--mobile-top {
      @include for-size(phone) {
        grid-area: top;
      }
    }

    &--mobile-bottom {
      @include for-size(phone) {
        grid-area: bottom;
      }
    }

    &--hide-mobile {
      @include for-size(phone) {
        display: none;
      }
    }

    &--mobile-100 {
      @include for-size(phone) {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    &--pagination {
      @include for-size(tablet) {
        grid-area: 1/3;
      }

      @include for-size(phone) {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    &--pagination-text {
      @include for-size(tablet) {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        grid-area: 2/1;
        margin-top: 24px;
      }
    }
  }

  &__column:nth-child(1) {
    @include for-size(tablet-or-larger) {
      justify-content: flex-start;
    }
  }

  &__column:nth-last-child(1) {
    @include for-size(tablet-or-larger) {
      justify-content: flex-end;
      grid-area: 1/3;
    }
  }

  &__items__label {
    margin-right: 8px;
  }

  &__items__control {
    width: 73px;
  }

  &__current__input {
    margin-left: 18px;
    margin-right: 8px;
    width: auto;
  }

  &__current__label {
    margin-right: 43px;
  }
}

.#{$prefix}pagination {
  display: flex;
  font-family: $font-family-base;
}

.#{$prefix}pagination-element {
  padding: 6px;
  margin: 0 2px;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  width: 24px;

  &.#{$prefix}disabled {
    pointer-events: none;
  }

  &.#{$prefix}active {
    background: v(paginationActiveBackground);
    color: v(paginationActiveColor);
  }

  &:hover:not(.#{$prefix}disabled) {
    background: v(paginationHoverBackground);
    color: v(paginationHoverColor);
    --contentHoverColor: var(--paginationHoverColor);
    --contentColor: var(--paginationHoverColor);
    transition: none;
  }
}

.#{$prefix}paging__current-button {
  padding: 2px 6px;
}

.#{$prefix}buttons {
  display: flex;
  gap: 8px;
  justify-content: center;
  padding-top: 24px;
}
